namespace Solovis.Reports.Parameters.Stats {

    export class SequenceEntryControl extends Solovis.UI.BaseControl {

        private _sequence: SequenceOptions;

        constructor(options) {
            super(options);

            this._sequence = options.sequence ? options.sequence : {};
        }

        public doRender() {
            this._updateLabel();
        }

        private _updateLabel() {
            let label;

            if (this._sequence.label) {
                label = this._sequence.label;
            }
            else {
                label = this._sequence.code ? this._sequence.code : "(Code not set)";

                if (this._sequence.type) {
                    label += "; " + this._sequence.type;
                }

                if (this._sequence.returnMode) {
                    label += "; " + this._sequence.returnMode;
                }

                if (this._sequence.annualizationMethod) {
                    label += "; " + this._sequence.annualizationMethod;
                }
            }

            this.container.text(label);
        }

        public getSequence() {
            return this._sequence;
        }

        public showEditDialog() {
            let editorDiv = $("<div>");

            let editorControl = new SequenceEditorControl({
                controlHost: editorDiv,
                sequence: this._sequence
            });

            let desiredWidth = Math.min($(window).width() * 0.9, 600);
            let desiredHeight = Math.min($(window).height() * 0.9, 650);

            let dialog = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "Edit Sequence",
                width: desiredWidth,
                height: desiredHeight,
                modal: true,
                center: true,
                autoOpen: true,
                actions: ["Close"],
                destroyOnClose: true,

                activate: () => {
                    editorControl.setAsCurrentControl();
                },

                buttons: [
                    {
                        label: "OK",
                        click: () => {
                            this._sequence = editorControl.getSequence();
                            this._updateLabel();
                            dialog.close();
                        }
                    },
                    {
                        label: "Cancel",
                        click: () => {
                            dialog.close();
                        }
                    }
                ],

                contentWidthSizer: {
                    setWidth: function (newWidth) {
                        editorControl.setWidth(newWidth);
                    }
                }
            });
        }
    }

}